export default "__VITE_ASSET__C8cZuyPL__"